import React from 'react';
import { Wand2, Sparkles, Video, Download } from 'lucide-react';
import { SettingsSection, SettingsToggle, SettingsSelect } from '../index';
import { TONE_OPTIONS } from '../../../constants/settings';

const TabAI = ({ settings, onChange }) => {
  const updateSetting = (key, value) => {
    onChange({ ...settings, [key]: value });
  };

  return (
    <div className="space-y-6">
      {/* AI Content Settings */}
      <SettingsSection title="Création de contenu IA" icon={Wand2}>
        <div className="space-y-6">
          <SettingsSelect
            label="Ton des publications"
            value={settings?.tone || 'professional'}
            onChange={(value) => updateSetting('tone', value)}
            options={TONE_OPTIONS}
          />

          {/* Prompt Customization Section */}
          <div className="border-t border-dark-border pt-6">
            <h3 className="text-sm font-medium text-primary mb-4">Personnalisation du prompt</h3>

            <div className="space-y-4">
              <SettingsToggle
                label="Utiliser des emojis"
                description="Ajouter des emojis aux publications générées"
                checked={settings?.prompt_use_emojis !== false}
                onChange={(value) => updateSetting('prompt_use_emojis', value)}
              />

              <SettingsToggle
                label="Génération automatique de hashtags"
                description="L'IA génère automatiquement des hashtags pertinents"
                checked={settings?.auto_hashtags !== false}
                onChange={(value) => updateSetting('auto_hashtags', value)}
              />

              <div>
                <label className="block text-sm font-medium text-label mb-2">
                  Mentions obligatoires
                </label>
                <input
                  type="text"
                  value={settings?.prompt_mandatory_mentions || ''}
                  onChange={(e) => updateSetting('prompt_mandatory_mentions', e.target.value)}
                  placeholder="Ex: Garantie 12 mois, Financement disponible"
                  className="w-full bg-dark-input border border-dark-border text-primary placeholder-muted rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-carmin"
                />
                <p className="text-xs text-muted mt-1">
                  Ces informations seront toujours mentionnées dans les publications
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-label mb-2">
                  Hashtags personnalisés
                </label>
                <input
                  type="text"
                  value={settings?.prompt_custom_hashtags || ''}
                  onChange={(e) => updateSetting('prompt_custom_hashtags', e.target.value)}
                  placeholder="Ex: #voiture #occasion #belgique"
                  className="w-full bg-dark-input border border-dark-border text-primary placeholder-muted rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-carmin"
                />
                <p className="text-xs text-muted mt-1">
                  Ces hashtags seront ajoutés à toutes les publications
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-label mb-2">
                  Instructions libres (optionnel)
                </label>
                <textarea
                  value={settings?.custom_prompt || ''}
                  onChange={(e) => updateSetting('custom_prompt', e.target.value)}
                  rows={4}
                  placeholder="Ex: Utiliser un vocabulaire technique, mettre en avant la qualité..."
                  className="w-full bg-dark-input border border-dark-border text-primary placeholder-muted rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-carmin"
                />
              </div>
            </div>
          </div>
        </div>
      </SettingsSection>

      {/* Import auto-generation settings */}
      <SettingsSection title="Import de véhicules" icon={Download}>
        <div className="space-y-6">
          <SettingsToggle
            label="Génération automatique de contenu"
            description="Générer automatiquement le contenu IA pour les véhicules importés"
            checked={settings?.auto_generate_on_import !== false}
            onChange={(value) => updateSetting('auto_generate_on_import', value)}
          />
        </div>
      </SettingsSection>

      {/* AI Image Generation - Coming Soon */}
      <SettingsSection title="Génération d'images IA" icon={Sparkles} iconColor="text-accent-purple">
        <div className="p-4 border border-dashed border-accent-purple/30 rounded-lg bg-accent-purple-bg">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-purple/20 text-accent-purple-light rounded-full">
              Bientôt disponible
            </span>
          </div>
          <p className="text-sm text-secondary">
            Générez des photos stylisées de vos véhicules en mouvement avec l'IA.
          </p>
          <p className="text-xs text-muted mt-1">
            Coût estimé : ~0.03€ par image générée
          </p>
        </div>
      </SettingsSection>

      {/* Video Generation - Coming Soon */}
      <SettingsSection title="Génération de vidéos" icon={Video} iconColor="text-pink-500">
        <div className="p-4 border border-dashed border-pink-500/30 rounded-lg bg-pink-900/20">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 text-xs font-medium bg-pink-900/50 text-pink-400 rounded-full">
              Bientôt disponible
            </span>
          </div>
          <p className="text-sm text-secondary">
            Créez automatiquement des vidéos promotionnelles pour vos véhicules.
          </p>
          <p className="text-xs text-muted mt-1">
            Une vidéo sera créée pour chaque nouveau véhicule
          </p>
        </div>
      </SettingsSection>
    </div>
  );
};

export default TabAI;
